"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _Button = _interopRequireDefault(require("../Button"));

var _remindList = _interopRequireDefault(require("./remindList.js"));

var _repeatList = _interopRequireDefault(require("./repeatList.js"));

var _dateUtils = _interopRequireDefault(require("../utils/dateUtils"));

var _Calendar = _interopRequireDefault(require("./Calendar.style"));

var _PeriodChange = _interopRequireDefault(require("./PeriodChange"));

var _WeekDays = _interopRequireDefault(require("./WeekDays"));

var _Days = _interopRequireDefault(require("./Days"));

var _DateTimeHeader = _interopRequireDefault(require("./DateTimeHeader"));

var _Options = _interopRequireDefault(require("./Options/Options"));

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

const OPTIONS = {
  time: 'time',
  dateRange: 'dateRange',
  sendInvite: 'sendInvite',
  timeZone: 'timeZone'
};
let Calendar = (_dec = (0, _reactJss.default)(_Calendar.default), _dec(_class = (0, _reactClickOutside.default)(_class = class Calendar extends _react.PureComponent {
  constructor(props) {
    super(props);
    const {
      startDate,
      endDate,
      timeZoneOffset,
      remindDate,
      repeatValue
    } = props.value;
    const {
      dateRange,
      time,
      remind,
      repeat,
      timeZone,
      sendInvite,
      isStatic
    } = props;
    const defaultUnix = this.getDefaultUnixTime();
    const startDateValue = startDate || defaultUnix;
    const value = isStatic ? this.getNormalizedStaticValue(startDateValue * 1000) : {
      startDate: startDateValue,
      endDate: dateRange ? endDate || defaultUnix : startDateValue
    };
    this.state = {
      value,
      time,
      dateRange,
      remind,
      repeat,
      timeZone,
      sendInvite,
      viewDate: new Date(value.startDate * 1000),
      maxDate: props.maxDate && new Date(props.maxDate * 1000),
      minDate: props.minDate && new Date(props.minDate * 1000),
      remindDate: remindDate || null,
      remindValue: this.getRemindValue(remindDate, value.startDate),
      repeatValue: repeatValue || _repeatList.default[0].value,
      timeZoneOffset: _dateUtils.default.getTimezoneOffset(timeZoneOffset, isStatic),
      options: this.initOptions(),
      rangePoint: 'start',
      isUpdating: false
    };
    this.handlePeriodChange = this.handlePeriodChange.bind(this);
    this.handleDaysChange = this.handleDaysChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.handleOptionsChange = this.handleOptionsChange.bind(this);
    this.handleClickConfirmButton = this.handleClickConfirmButton.bind(this);
    this.handleQuickDateSelect = this.handleQuickDateSelect.bind(this);
    this.setTimeIsUpdating = this.setTimeIsUpdating.bind(this);
  } // Установить стартовые состояния опций (time, dateRange, sendInvite) из props


  initOptions() {
    const {
      options = [],
      isStatic
    } = this.props;
    const result = {};
    options.forEach(option => {
      if (isStatic && option !== OPTIONS.sendInvite) return;
      result[option] = this.props[option] || false;
    });
    return result;
  }

  getNormalizedStaticValue(timestamp) {
    const utcDate = _dateUtils.default.adjustTimezoneOffset(_dateUtils.default.startOf(timestamp, 'day') / 1000);

    return {
      startDate: utcDate,
      endDate: utcDate,
      timeZoneOffset: 0
    };
  } // Получить значение remindValue (индекс в REMIND_LIST)


  getRemindValue(remindDate, startDate) {
    let remindValue = _remindList.default[0].value;

    if (remindDate) {
      remindValue = _remindList.default.findIndex(item => startDate - remindDate === item.value);
    }

    return remindValue.toString();
  }

  static getDerivedStateFromProps(props, state) {
    const {
      options,
      value
    } = state;
    const changes = {
      options: _objectSpread({}, options)
    };

    const updateIfChanged = propName => {
      if (props[propName] === state[propName]) return;
      changes[propName] = props[propName];

      if (Object.prototype.hasOwnProperty.call(options, propName)) {
        changes.options[propName] = props[propName];
      }

      if (propName === OPTIONS.dateRange) {
        changes.value = _objectSpread(_objectSpread({}, value), {}, {
          endDate: value.startDate
        });
      }
    };

    ['isStatic', 'remind', 'repeat', 'sendInvite'].forEach(updateIfChanged);

    if (props.isStatic) {
      var _props$options;

      changes.timeZone = false;
      changes.time = false;
      changes.dateRange = false;
      changes.timeZoneOffset = 0;
      changes.options = (_props$options = props.options) !== null && _props$options !== void 0 && _props$options.includes(OPTIONS.sendInvite) ? {
        [OPTIONS.sendInvite]: options[OPTIONS.sendInvite] || false
      } : {};
    } else {
      var _props$options2;

      [OPTIONS.timeZone, OPTIONS.time, OPTIONS.dateRange].forEach(updateIfChanged);

      if ((_props$options2 = props.options) === null || _props$options2 === void 0 ? void 0 : _props$options2.length) {
        props.options.forEach(option => Object.prototype.hasOwnProperty.call(changes.options, option) || (changes.options[option] = props[option]));
      }

      if (Object.hasOwn(changes, 'isStatic')) {
        changes.timeZoneOffset = _dateUtils.default.getTimezoneOffset(props.timeZoneOffset);
      }
    }

    return Object.keys(changes).length ? _objectSpread({}, changes) : null;
  } // Время по умолчанию в 12:00


  getDefaultUnixTime() {
    const {
      time
    } = this.props;
    const date = new Date();

    if (time) {
      date.setHours(12, 0, 0, 0);
    } else {
      date.setHours(0, 0, 0, 0);
    }

    return Math.floor(new Date(date).getTime() / 1000);
  } // Handler for click outside of component


  handleClickOutside() {
    const {
      onClose
    } = this.props;
    onClose();
  } // Обработчик смены года/месяца


  handlePeriodChange(value) {
    this.setState({
      viewDate: value
    });
  }

  updateDate(viewDate) {
    const {
      isStatic,
      defaultStartTime
    } = this.props;

    if (isStatic) {
      const value = this.getNormalizedStaticValue(viewDate.getTime());
      this.setState({
        value,
        viewDate
      });
      return;
    }

    const {
      value
    } = this.state;

    if (defaultStartTime) {
      const {
        hours = 0,
        min = 0,
        sec = 0,
        ms = 0
      } = defaultStartTime;
      viewDate.setHours(hours, min, sec, ms);
    }

    const unix = _dateUtils.default.dateToUnixtime(viewDate);

    const newValue = _objectSpread(_objectSpread({}, value), {}, {
      startDate: unix,
      endDate: unix
    });

    this.setState({
      value: newValue,
      viewDate
    });
  }

  updateRange(viewDate) {
    const {
      rangePoint
    } = this.state;
    const {
      defaultStartTime,
      defaultEndTime
    } = this.props;

    const unix = _dateUtils.default.dateToUnixtime(viewDate);

    let value = _objectSpread(_objectSpread({}, this.state.value), {}, {
      [`${rangePoint}Date`]: unix
    });

    if (rangePoint === 'start') {
      value.endDate = value.startDate;
    }

    if (value.startDate > value.endDate) {
      value = this.reverseRange(value);
    }

    if (defaultStartTime) {
      const {
        hours = 0,
        min = 0,
        sec = 0,
        ms = 0
      } = defaultStartTime;
      const defaultStartDate = new Date(value.startDate * 1000);
      defaultStartDate.setHours(hours, min, sec, ms);
      value.startDate = _dateUtils.default.dateToUnixtime(defaultStartDate);
    }

    if (defaultEndTime) {
      const {
        hours = 23,
        min = 59,
        sec = 0,
        ms = 0
      } = defaultEndTime;
      const defaultEndDate = new Date(value.endDate * 1000);
      defaultEndDate.setHours(hours, min, sec, ms);
      value.endDate = _dateUtils.default.dateToUnixtime(defaultEndDate);
    }

    this.setState({
      value,
      viewDate,
      rangePoint: rangePoint === 'start' ? 'end' : 'start'
    });
  }

  reverseRange({
    startDate,
    endDate
  }) {
    return {
      startDate: endDate,
      endDate: startDate
    };
  } // Обработчик изменения даты


  handleDaysChange({
    year,
    month,
    day
  }) {
    const viewDate = new Date(this.state.viewDate.getTime());
    const oldValueDate = new Date(this.state.value.startDate * 1000);
    viewDate.setMonth(month - 1, day);
    viewDate.setFullYear(year);
    viewDate.setHours(oldValueDate.getHours(), oldValueDate.getMinutes());

    if (this.isRange()) {
      this.updateRange(viewDate);
    } else {
      this.updateDate(viewDate);
    }
  } // Обработчик изменения времени


  handleTimeChange({
    id,
    unix
  }) {
    const {
      value
    } = this.state;

    if (this.isRange()) {
      this.setState({
        value: _objectSpread(_objectSpread({}, value), {}, {
          [id]: unix
        })
      });
    } else {
      this.setState({
        value: _objectSpread(_objectSpread({}, value), {}, {
          startDate: unix,
          endDate: unix
        })
      });
    }
  } // Получить время напоминания (unixtime)


  getRemindDate(remindValue) {
    const {
      value
    } = this.state;

    if (+remindValue) {
      return value.startDate - _remindList.default[remindValue].value;
    }

    return null;
  } // Получить частоту повторения


  getRepeatValue(repeatValue) {
    return _repeatList.default[repeatValue] ? _repeatList.default[repeatValue].value : _repeatList.default[0].value;
  } // Применить выбранную дату, таймзону, время напоминания


  handleClickConfirmButton() {
    const {
      id,
      onChange,
      onSubmit
    } = this.props;
    const {
      timeZoneOffset,
      remind,
      remindValue,
      repeat,
      repeatValue,
      sendInvite,
      options
    } = this.state;
    const settings = {
      timeZoneOffset: +timeZoneOffset,
      sendInvite: Object.prototype.hasOwnProperty.call(options, OPTIONS.sendInvite) ? options.sendInvite : sendInvite
    };
    if (remind) settings.remindDate = this.getRemindDate(remindValue);
    if (repeat) settings.repeatValue = this.getRepeatValue(repeatValue);

    const value = _objectSpread(_objectSpread({}, this.state.value), settings); // выполнение колбэков


    onChange({
      id,
      value,
      error: false
    });
    onSubmit();
  } // Применить выбранную дату по двойному клику


  handleQuickDateSelect(value) {
    if (this.isRange()) return;
    this.handleDaysChange(value);
    this.handleClickConfirmButton();
  } // Обработка смены настроек пользователем


  handleOptionsChange({
    id,
    value
  }) {
    const {
      options
    } = this.state;

    switch (id) {
      case OPTIONS.dateRange:
        this.handleRangeOptionChange(value);
        break;

      case OPTIONS.time:
        this.handleTimeOptionChange(value);
        break;

      case OPTIONS.sendInvite:
        this.setState({
          options: _objectSpread(_objectSpread({}, options), {}, {
            [id]: value
          })
        });
        break;

      default:
        this.setState({
          [id]: value
        });
    }
  } // Включение/выключение диапазона дат


  handleRangeOptionChange(dateRange) {
    const {
      value,
      options
    } = this.state;
    const rangePoint = dateRange ? 'end' : 'start';
    this.setState({
      value: _objectSpread(_objectSpread({}, value), {}, {
        endDate: value.startDate
      }),
      options: _objectSpread(_objectSpread({}, options), {}, {
        dateRange
      }),
      rangePoint
    });
  } // Включение/выключение времени


  handleTimeOptionChange(time) {
    const {
      value,
      options
    } = this.state;
    const hours = time ? 12 : 0;
    const startDate = this.setDefaultTime(value.startDate, hours, 0);
    const endDate = this.setDefaultTime(value.endDate, hours, 0);
    this.setState({
      value: _objectSpread(_objectSpread({}, value), {}, {
        startDate,
        endDate
      }),
      options: _objectSpread(_objectSpread({}, options), {}, {
        time
      })
    });
  }

  setTimeIsUpdating(value) {
    this.setState({
      isUpdating: value
    });
  }

  setDefaultTime(unix, hours, minutes) {
    const date = new Date(unix * 1000);
    date.setHours(hours);
    date.setMinutes(minutes);
    return _dateUtils.default.dateToUnixtime(date);
  }

  isRange() {
    const {
      options,
      dateRange,
      isStatic
    } = this.state;
    if (isStatic) return false;
    return Object.prototype.hasOwnProperty.call(options, OPTIONS.dateRange) ? options.dateRange : dateRange;
  }

  render() {
    const {
      classes,
      className,
      id,
      visibility,
      size,
      isoDays,
      maxDate: max,
      minDate: min
    } = this.props;
    const {
      value,
      options,
      viewDate,
      maxDate,
      minDate,
      time,
      remind,
      repeat,
      remindValue,
      repeatValue,
      timeZone,
      timeZoneOffset,
      isUpdating
    } = this.state;
    const {
      startDate,
      endDate
    } = value;
    const isRange = this.isRange();
    const isCorrectTime = startDate <= endDate;
    const isValidStart = !min || startDate >= min;
    const isValidEnd = !max || endDate <= max;
    const displayTime = Object.prototype.hasOwnProperty.call(options, OPTIONS.time) ? options.time : time;
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.calendar, classes[size], classes[visibility])
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.header, classes[size], {
        isRange
      })
    }, /*#__PURE__*/_react.default.createElement(_DateTimeHeader.default, {
      id: "startDate",
      size: size,
      isoDays: isoDays,
      unix: startDate,
      displayTime: displayTime,
      rangeError: !isValidStart,
      onTimeChange: this.handleTimeChange,
      onDateChange: this.handleDaysChange,
      onUpdate: ({
        isUpdating
      }) => this.props.updateOnInputChange && this.setTimeIsUpdating(isUpdating),
      updateOnInputChange: this.props.updateOnInputChange
    }), isRange ? /*#__PURE__*/_react.default.createElement(_DateTimeHeader.default, {
      id: "endDate",
      size: size,
      isoDays: isoDays,
      unix: endDate,
      displayTime: displayTime,
      rangeError: !isValidEnd,
      timeError: !isCorrectTime,
      onTimeChange: this.handleTimeChange,
      onDateChange: this.handleDaysChange
    }) : null), /*#__PURE__*/_react.default.createElement(_PeriodChange.default, {
      size: size,
      viewDate: viewDate,
      minDate: minDate,
      maxDate: maxDate,
      onChange: this.handlePeriodChange
    }), /*#__PURE__*/_react.default.createElement(_WeekDays.default, {
      size: size,
      isoDays: isoDays
    }), /*#__PURE__*/_react.default.createElement(_Days.default, {
      size: size,
      minDate: minDate,
      maxDate: maxDate,
      isoDays: isoDays,
      startDate: startDate,
      endDate: endDate,
      viewDate: viewDate,
      onChange: this.handleDaysChange,
      onDoubleClick: this.handleQuickDateSelect
    }), remind || repeat || timeZone || Object.keys(options).length !== 0 ? /*#__PURE__*/_react.default.createElement(_Options.default, {
      size: size,
      time: time,
      remind: remind,
      remindValue: remindValue,
      repeat: repeat,
      repeatValue: repeatValue,
      timeZone: timeZone,
      timeZoneOffset: timeZoneOffset,
      options: options,
      onChange: this.handleOptionsChange
    }) : null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: (0, _clsx.default)(classes.confirmButton, 'button'),
      label: displayTime ? 'Choose the date and time' : 'Choose the date',
      onClick: this.handleClickConfirmButton,
      size: size,
      disabled: !isCorrectTime || !isValidStart || !isValidEnd || isUpdating
    }));
  }

}) || _class) || _class);
Calendar.defaultProps = {
  visibility: 'visible',
  size: 'small',
  isoDays: true,
  value: {},
  maxDate: '',
  minDate: '',
  time: false,
  dateRange: false,
  sendInvite: false,
  remind: false,
  repeat: false,
  timeZone: false,
  isStatic: false,
  onChange: () => {},
  onClose: () => {},
  onSubmit: () => {},
  updateOnInputChange: false
};
var _default = Calendar;
exports.default = _default;